import React, {useEffect, useRef, useState} from "react";
import commonClose from "../../../assets/img/commonClose.png";
import commonInput from "../../../assets/img/commonInput.png";
import {useTranslation} from "react-i18next";
import axios from "../../../services/axiosInstance";
import {useLocation, useNavigate} from "react-router-dom";
import useTheme from "../layoutscommon/DarkModeStorage";
import "../../../css/web/UserModalRenew.css";

function PickupTrackAddPopup({ trackNumAddSt, closeTrackNumAddSt, pickupSeqNum, handleSaveTrackNum }) {
    const {t} = useTranslation();
    const [theme] = useTheme();
    const location = useLocation();
    const navigate = useNavigate()

    const [trackNum, setTrackNum] = useState("");
    const [trackNumError, setTrackNumError] = useState(false);

    const [isSaveBtLoading, setIsSaveBtLoading] = useState(false);
    const [isSaveBtDisabled, setIsSaveBtDisabled] = useState(false);
    const [saveComplMsg, setSaveComplMsg] = useState(false);

    const handleTrackNumChange = (e) => { /* 두번 째 이메일 주소가 xx.xx가 아니면 에러메시지*/
        setTrackNum(e.target.value);
        if (e.target.value !== "") setTrackNumError(false);
    };

    const handleSubmit = () => {
        if (trackNum === "" || trackNum === null) {
            setTrackNumError(true);
            return;
        }
        savePickupTrackNum();
    };

    const savePickupTrackNum = () => {
        setIsSaveBtLoading(true);
        setIsSaveBtDisabled(true);

        axios({
            method: 'post',
            url: '/pickup/updateTrackNum', // 백엔드 엔드포인트 확인
            params: {
                seqNum: pickupSeqNum,
                trackNum: trackNum,
            },
        })
            .then((response) => {
                const updatedData = response.data;
                setSaveComplMsg(true);

                // 부모 UI 실시간 업데이트
                handleSaveTrackNum(updatedData);

                // 2초 뒤 팝업 닫기
                setTimeout(() => {
                    closeTrackNumAddSt();
                }, 1000);
            })
            .catch((error) => {
                console.error('운송장 저장 실패:', error);
                setIsSaveBtDisabled(false);
            })
            .finally(() => {
                setIsSaveBtLoading(false);
            });
    };







    return (
        <div className="position-fixed wd-100pc ht-100pc display-flex just-cont-center align-center md-scope" data-theme={theme}
             style={{top: "0", left: "0", zIndex: 1000, background: "var(--md-backdrop, rgba(0, 0, 0, 0.3))"}}>
            <div className="wd-350"
                 style={{background: "var(--md-surface, white)", color: "var(--md-text)", boxShadow: "var(--md-shadow, 0 0 10px rgba(0, 0, 0, 0.5))", borderRadius: "14px"}}>
                <div className="wd-100pc"
                     style={{borderBottom: "solid 1px var(--md-border, #EAEAEA)", height: "70px", display: "flex", padding: "10px"}}>
                    <div className="display-flex align-center justify-content-between wd-100pc p-l-10 p-r-10">
                        <div className="user-center">
                            <div className="ht-100pc display-flex just-cont-center align-center">
                                <img className="wd-30 ht-30" alt='' src={commonInput}/>
                            </div>
                            <div style={{height: "100%", display: "flex", alignItems: "center"}}>
                                <p className="font-t-title font-s-18 m-t-2 m-l-10">Tracking Number</p>
                            </div>
                        </div>
                        <div className="user-center ht-100pc">
                            <img className="wd-30 ht-30 m-a-opc-07 c-point" onClick={closeTrackNumAddSt}
                                 src={commonClose} alt="close"/>
                        </div>
                    </div>
                </div>

                {/*운송장 영역*/}
                    <div>
                        <div className="p-l-20 p-r-20 p-b-20 m-t-10">
                            <div
                                className="user-input-container wd-100pc ht-50 display-flex align-center just-cont-center">
                                <input onChange={(e) => handleTrackNumChange(e)} maxLength={35}
                                       onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
                                       type="text"
                                       className="user-input wd-100pc ht-45 border-rd4 font-s-14 font-t-cont"
                                       style={{padding: "0 10px", color: "var(--md-text)"}} placeholder="운송장번호"
                                       value={trackNum}/>
                            </div>
                            {trackNumError ?
                                <div className="JoinErrorMsg font-t-cont m-t-10">
                                    <p className="JoinErrMsg">{t('ptapTx1')}</p>
                                </div>
                                :
                                null
                            }

                        </div>
                    </div>


                { saveComplMsg ?
                    <div className="JoinErrorMsg" style={{textAlign: "center"}}>
                        <p className="JoinErrMsg">{t(`eipTx1`)} &#128521;</p>
                    </div>
                    :
                    null
                }

                <div className="display-flex just-cont-fend align-center pd20">
                    <button className="bt-btn-D-B font-s-15" style={{padding: "10px 20px"}}
                            onClick={closeTrackNumAddSt}>
                        <div>{t(`myPc15`)}</div>
                    </button>
                    {/*취소버튼*/}

                    <button className="bt-btn-B font-s-15 m-l-10" style={{padding: "10px 20px"}}
                            onClick={() => handleSubmit()} disabled={isSaveBtDisabled}>
                        {isSaveBtLoading ? (
                            <div className="spinner"></div>
                        ) : (
                            <div>{t(`saveBt`)}</div>
                        )}
                    </button>
                    {/*저장버튼*/}
                </div>

            </div>
        </div>
    )
}

export default PickupTrackAddPopup